const ALLIANCE_CHART = {
  procedure: 'Interlaminar spacer',
  caseType: 'Thoracic, lumbar, and/or sacral',
};

export const ENROLLMENT_STUDIES = [
  {
    id: 'alliance',
    name: 'Alliance',
    consent: { phaseId: 'enrollment', visitId: '', formId: 'consent' },
  },
  {
    id: 'compass',
    name: 'Compass',
    consent: { phaseId: 'enrollment', visitId: '', formId: 'consent' },
  },
];

function isCoflex(procedureKey) {
  return /coflex/i.test(String(procedureKey || ''));
}

/** Study choices for the enrollment popup. A Coflex decision still carries Alliance chart defaults. */
export function enrollmentStudyChoices(procedureKey) {
  return ENROLLMENT_STUDIES.map((study) => {
    const choice = { ...study, consent: { ...study.consent } };
    if (study.id === 'alliance' && isCoflex(procedureKey)) {
      choice.chart = { ...ALLIANCE_CHART };
    }
    return choice;
  });
}

export function studyConsentHandoff({
  procedureKey,
  procedureLabel = '',
  surgeryDate = '',
  characteristics = null,
} = {}) {
  return {
    studies: enrollmentStudyChoices(procedureKey),
    procedureKey,
    procedureLabel,
    surgeryDate,
    characteristics: characteristics && typeof characteristics === 'object' ? characteristics : {},
    askConsent: true,
  };
}

export function consentAskCopy() {
  return {
    title: 'Begin Enrollment',
    detail: 'Would you like to begin enrolling this patient in a study? Choose one or more from the drop down list.',
  };
}
